// removed by extract-text-webpack-plugin
module.exports = {"PayResultWrap":"style__PayResultWrap___33sSx","PayResult":"style__PayResult___2qoS7","PayResultIcon":"style__PayResultIcon___16owh","PayResultTitle":"style__PayResultTitle___bxdUd","PayResultText":"style__PayResultText___sw3N4","PayResultButton":"style__PayResultButton___2vZdS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payments/SuccessPage/style.scss
// module id = 1431
// module chunks = 0